import { CheckOutlined } from "@ant-design/icons"
import { useContext } from "react"
import styles from "./index.module.scss"
import { PictureViewerContext } from "../hooks/PictureViewerContext"

export default function PicViewerBottomMultiple ({
    items = [],
    onFocus,
    onStatusChange,
}) {
    const context = useContext(PictureViewerContext)
    const { allowStatusDeselect } = context.controls

    return (
        <div className={styles.PicViewerBottomMultiple}>
            {items.map((item) => {
                const image = item.image || {}
                
                const {
                    status, // 'approved' | 'rejected' | 'modified' | null
                    approveText="可用",
                    approvedText="可用",
                    rejectText="需修改",
                    rejectedText="需修改",
                    cancelText="取消",
                    canceledText="已取消",
                    approveDisabled=false, // 是否禁用可用按钮
                    rejectDisabled=false, // 是否禁用拒绝按钮
                    cancelDisabled=false, // 是否禁用取消按钮
                    downloadDisabled=true, // 是否禁用下载按钮
                    readOnly=false, // 是否只读模式
                } = image
                
                return (
                    <div
                        key={item.slotIndex}
                        className={`${styles.ActionGroup} ${item.isActive ? styles.active : ''}`}
                        onClick={() => onFocus?.(item.imageIndex)}
                    >
                        <div
                            className={`${styles.ActionBtn} ${styles.Canceled} ${status === 'canceled' ? styles.activeBtn : ''} ${readOnly || cancelDisabled ? styles.disabled : ''}`}
                            style={(readOnly || cancelDisabled) && status != "canceled" ? {display:"none"} : null}
                            onClick={(event) => {
                                event.stopPropagation()
                                if (readOnly || cancelDisabled) return
                                onFocus?.(item.imageIndex)
                                onStatusChange?.(item.imageIndex, status === 'canceled' && allowStatusDeselect ? null : 'canceled')
                            }}
                        >
                            {status === 'canceled' ? <CheckOutlined /> : null}
                            {status === 'canceled' ? canceledText : cancelText}
                        </div>
                        <div
                            className={`${styles.ActionBtn} ${styles.Rejected} ${status === 'rejected' ? styles.activeBtn : ''} ${readOnly || rejectDisabled ? styles.disabled : ''}`}
                            style={(readOnly || rejectDisabled) && status != "rejected" ? {display:"none"} : null}
                            onClick={(event) => {
                                event.stopPropagation()
                                if (readOnly || rejectDisabled) return
                                onFocus?.(item.imageIndex)
                                onStatusChange?.(item.imageIndex, status === 'rejected' && allowStatusDeselect ? null : 'rejected')
                            }}
                        >
                            {status === 'rejected' ? <CheckOutlined /> : null}
                            {status === 'rejected' ? rejectedText : rejectText}
                        </div>
                        <div
                            className={`${styles.ActionBtn} ${styles.Approved} ${(!status || status === 'modified') ? styles.default : ''} ${status === 'approved' ? styles.activeBtn : ''} ${readOnly ? styles.disabled : ''}`}
                            style={(readOnly || approveDisabled) && status != "approved" ? {display:"none"} : null}
                            onClick={(event) => {
                                event.stopPropagation()
                                if (readOnly || approveDisabled) return
                                onFocus?.(item.imageIndex)
                                onStatusChange?.(item.imageIndex, status === 'approved' && allowStatusDeselect ? null : 'approved')
                            }}
                        >
                            {status === 'approved' ? <CheckOutlined /> : null}
                            {status === 'approved' ? approvedText : approveText}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
